import UNIQUE from '@/common/unique'
import columnDetail from '../columnDetail'
export default {
  id: 'smartkey',
  name: 'smartkey',
  type: 'standard',
  moduleName: 'editor_module_smartkey',
  dataSet: {
    mods: 'smartkey',
    extra: true,
    column: [
      {
        columnId: UNIQUE.mid(),
        type: 'smartkey',
        value: null,
        detail: {
          options: ['smartkey', 'text', 'border', 'background', 'padding', 'radius'],
          smartkey: columnDetail.smartkey
        }
      },
      {
        columnId: UNIQUE.mid(),
        type: 'remotekey',
        value: null,
        detail: {
          options: ['remotekey', 'border', 'background', 'padding', 'radius'],
          remotekey: columnDetail.remotekey
        }
      }
    ]
  },
  setting: {
    layout: {
      options: [
        'background',
        'border',
        'padding'
      ]
    },
    action: null,
    detail: {}
  }
}
